import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import { Alert } from 'reactstrap';
import LoaderButton from "../components/LoaderButton";

const schema = Yup.object({
  confirmationCode: Yup.string().required()
});

export default class Verification extends Component {
  constructor(props) {
    super(props);

    var persistentEmail = "";
    if (props.emailAddress !== "") {
      localStorage.setItem('emailAddress',props.emailAddress);
      persistentEmail = props.emailAddress;
    }
    else {
      persistentEmail = localStorage.getItem('emailAddress');
    }

    this.state = {
      isLoading: false,
      confirmationCode: "",
      alertMessage: "",
      infoMessage: "",
      email: persistentEmail,
      newUser: null
    };
  }

  onDismissAlert = () => this.setState({ alertMessage: "" });
  onDismissInfo = () => this.setState({ infoMessage: "" });;

  resendConfirmation = async event => {
    try {
      this.setState({ alertMessage: "", infoMessage: "" })
      await Auth.resendSignUp(this.state.email);
      this.setState({ infoMessage: "Code requested, please check your email email"});
    } catch (e) {
      this.setState({ alertMessage: e.message});
    }
  }

  handleSubmit = async event => {
   
    this.setState({ isLoading: true, alertMessage: "", infoMessage: "" });

    try {
      await Auth.confirmSignUp(this.state.email, event.confirmationCode);
     // await Auth.signIn(this.state.email, this.state.password);
     // this.props.userHasAuthenticated(true);
      this.props.history.push("/");
    } catch (e) {
      this.setState({ alertMessage: e.message});   
    }
    this.setState({ isLoading: false });
  }

  renderConfirmationForm() {
    return (
      <div>
      <Formik
      validateOnChange={false}
      validationSchema={schema}
      onSubmit={this.handleSubmit}
      initialValues={{
        email: this.state.email,
        confirmationCode: ''
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <div>
        <Alert color="warning" isOpen={!this.state.alertMessage == ""} toggle={this.onDismissAlert} fade={false}>
          <h4 className="alert-heading">Error</h4>
          <p>{this.state.alertMessage}</p>
        </Alert>
        <Alert color="success" isOpen={!this.state.infoMessage == ""} toggle={this.onDismissInfo} fade={false}>
          <h4 className="alert-heading">Information</h4>
          <p>{this.state.infoMessage}</p>
        </Alert>
        <Form noValidate onSubmit={handleSubmit}>
          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control className="form-control-sm"
              name="email"
              value={values.email}
              type="email"
              disabled="true"
            />
            <Form.Control.Feedback type="invalid">
              {errors.confirmationCode}
            </Form.Control.Feedback>
            <Form.Text className="text-muted">
              <Link Style={"font-size: 1em;"} onClick={() => this.resendConfirmation()}>Resend confirmation code?</Link>  
            </Form.Text>    
          </Form.Group>
          <Form.Group controlId="confirmationCode">
            <Form.Label>Confirmation Code</Form.Label>
            <Form.Control className="form-control-sm"
              name="confirmationCode"
              value={values.confirmationCode}
              placeholder="Enter code"
              type="code"
              onChange={handleChange}
              isInvalid={!!errors.confirmationCode}
            />
            <Form.Control.Feedback type="invalid">
              {errors.confirmationCode}
            </Form.Control.Feedback>
            <Form.Text className="text-muted">Please check your email for the code.</Form.Text>    
          </Form.Group>

        <LoaderButton
          block
          bsSize="small"
          type="submit"
          isLoading={this.state.isLoading}
          text="Verify"
          loadingText="Verifying…"
        />
      </Form>
      </div>
    )}
    </Formik></div>
  );
  }

  render() {
    return (
      <div className="main">
        {this.renderConfirmationForm()}
      </div>
    );
  }
}
